module.exports = __webpack_public_path__ + "img/614.38789808.png";